import { useCallback } from "react";
import { useDispatch, useStore } from "react-redux";
import { RootState, useAppSelector } from "src/store";
import { usePlansApi } from "../api";
import { resetError, resetList, setError, setFilter, setList, setLoading } from "../slices";

export const usePlansService = () => {
  const dispatch = useDispatch();
  const { getState } = useStore<RootState>();
  const { loading, filter, list, error } = useAppSelector((state) => state.plans);

  const api = usePlansApi();

  const getPlans = useCallback(async () => {
    const filter = getState().plans.filter;

    try {
      dispatch(resetError());
      dispatch(setLoading({ getList: true }));

      const response = await api.getAdminPlans({
        applicationId: filter.applicationId,
        limit: filter.limit,
        offset: filter.offset,

        query: filter.query || undefined,
        sort: filter.sort,
        companyId: filter.companyId,
        types: filter.types,
        statuses: filter.statuses,
      });
      dispatch(setList(response.data));

      return response.data;
    } catch (e) {
      dispatch(setError(e));
      throw e;
    } finally {
      dispatch(setLoading({ getList: false }));
    }
  }, []);

  const changePlansFilter = useCallback((filter: Partial<RootState["plans"]["filter"]>) => {
    dispatch(setFilter(filter));
  }, []);

  const resetPlans = useCallback(() => {
    dispatch(resetList());
  }, []);

  return {
    loading,
    filter,
    list,
    error,
    getPlans,
    changePlansFilter,
    resetPlans,
  };
};
